var shopID = '689fc5103fcab551fdd09bd9';
var GSenabledProductList = [10011824980247,10011824947479];

async function replaceWithCustomAddToCartButton() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  // --- Handle normal Shopify product forms ---
  if (forms.length > 1) {
    forms.forEach((form, idx) => {
      if (idx > 0) {
        form.remove();
      }
    });
  }

  forms.forEach((form, idx) => {
    if (idx > 0) return;

    // Remove default buttons + spinners + Shop Pay button
    const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"], button[type="button"]');
    buttons.forEach(btn => btn.remove());

    const spinners = form.querySelectorAll('.loading__spinner, .loading-overlay__spinner');
    spinners.forEach(spinner => spinner.remove());

    const paymentWrapper = form.querySelector('[data-shopify="payment-button"], .shopify-payment-button, .additional-checkout-buttons');
    if (paymentWrapper) paymentWrapper.remove();

    // Insert our button
    insertCustomBtn(form);
    
    // Re-run if variants are switched
    document.querySelectorAll("button[data-action='select-value'], .product-form__input input[type=radio]").forEach(variant => {
      variant.addEventListener('click', () => {
        setTimeout(() => replaceWithCustomAddToCartButton(), 200);
      });
    });
  });

  // --- Handle GangSheet uploader products ---
  const gsWrapper = document.querySelector('.gs--wrapper .gs-uploader-wrapper');
  if (gsWrapper) {
    // Remove uploader and hidden add-to-cart buttons
    const uploaderBtn = gsWrapper.querySelector('#gs-uploader-btn');
    if (uploaderBtn) uploaderBtn.remove();

    const gsAddBtn = gsWrapper.querySelector('#gs-add-cart-btn');
    if (gsAddBtn) gsAddBtn.remove();

    // Insert our custom button
    insertCustomBtn(gsWrapper);
  }
}

// Helper: insert button (safe, only once)
function insertCustomBtn(container) {
  // Prevent duplicate buttons
  if (container.querySelector('.my-custom-add-button')) {
    return; // button already exists
  }

  const customBtn = document.createElement('button');
  customBtn.type = 'button';
  customBtn.innerText = 'Build your GangSheet';
  customBtn.className = 'my-custom-add-button';
  customBtn.style.cssText = `
    width: 100%;
    padding: 12px;
    background: #000;
    color: #fff;
    font-size: 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 10px;
  `;

  // Prefer Shopify form button containers, else append directly
  const containerEl = container.querySelector(
    '.product-form__buttons, .product-form, .product-single__form, .product__buttons'
  );
  if (containerEl) {
    containerEl.appendChild(customBtn);
  } else {
    container.appendChild(customBtn);
  }
}

async function clearCart() {
  await fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
  });
}

// Hide specific cart properties from being shown in the cart UI
function hideCartProperties() {
  const propertyLabels = document.querySelectorAll('.cart__item, .cart-item');
  propertyLabels.forEach(item => {
    const propertyRows = item.querySelectorAll('li, .cart__property, .product-option');
    propertyRows.forEach(row => {
      const text = row.textContent || '';
      if (text.includes('unique_key') || text.includes('Created At')) {
        row.style.display = 'none';
      }
    });
  });
}

async function runner() {
  const pathname = window.location.pathname;
  if (pathname.includes('/products/')) {
    if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      const product = ShopifyAnalytics.meta.product;
      console.log("Product ID:", product.id);
      if (GSenabledProductList.includes(product.id)) {
        await replaceWithCustomAddToCartButton();
      }
    }

  } else if (pathname === '/cart' || pathname.includes('/cart')) {
    const urlParams = new URLSearchParams(window.location.search);
    let oldVariantId = urlParams.get('oldVariantId');
    let addedItemsParam = urlParams.get('items');
    
    // Only parse and process if both parameters exist
    if (oldVariantId && addedItemsParam) {
      let addedItems;
      try {
        addedItems = JSON.parse(addedItemsParam);
      } catch (parseError) {
        console.error('Error parsing items parameter:', parseError);
        return; // Exit if items can't be parsed
      }
      let cart;
      try {
        const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
        cart = await cartRes.json();
      } catch (err) {
        console.error('Error fetching cart:', err);
        cart = { items: [] };
      }

      // Remove all items with oldVariantId and no canvasId
      const removalPromises = cart.items
        .filter(item => String(item.variant_id) === String(oldVariantId) && !(item.properties && item.properties.canvasId))
        .map(item => {
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          }).catch(error => {
            console.error('Error updating cart for key', item.key, error);
          });
        });

      if (removalPromises.length > 0) {
        await Promise.all(removalPromises);
      }

      // Now add new items
      let items = [];
      for (let i = 0; i < parseInt(addedItems.length); i++) {
          const timestamp = new Date().getTime() + i * 1000;
          const readableTime = new Date(timestamp).toLocaleString();
          items.push({
            id: addedItems[i].variantId,
            quantity: addedItems[i].quantity,
            properties: {
              _timestamp: timestamp,
              'Created At': readableTime,
              canvasId: addedItems[i].id,
              portalURL: 'https://gangsheetbuilder.pixelflowdtf.com/load?canvasId=' + addedItems[i].id,
              unique_key: `${addedItems[i].variantId}_${timestamp}`
            }
          });
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const result = await response.json();
        window.location.href = window.location.pathname;

      } catch (error) {
        console.error('Error adding items:', error);
      }
    } else {
      // Normal cart page visit (no items to add)
      console.log("You're on the cart page");
    }
  }
}

// Function to ensure runner is called
function initRunner() {
    runner().then(hideCartProperties).catch(err => console.error('Runner error:', err));
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initRunner();
}

document.addEventListener('DOMContentLoaded', initRunner);
window.addEventListener('load', initRunner);

// Event delegation for custom add-to-cart button
function handleCustomAddToCartClick(event) {
  const btn = event.target.closest('.my-custom-add-button');
  if (!btn) return;
  event.preventDefault();

  const form = btn.closest('form');
  if (!form) return;

  (async () => {
    try {
      // Get product information from Shopify Analytics (without adding to cart)
      let productId, variantId, quantity = 1;

      // Method 1: Get product ID from Shopify Analytics
      if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        productId = ShopifyAnalytics.meta.product.id;
        
        // Get selected variant ID from Shopify Analytics
        if (ShopifyAnalytics.meta.product.selected_or_first_available_variant) {
          variantId = ShopifyAnalytics.meta.product.selected_or_first_available_variant;
        } else if (ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants.length > 0) {
          variantId = ShopifyAnalytics.meta.product.variants[0].id;
        }
      }

      // Method 2: Try to get variant ID from form inputs (most common method)
      if (!variantId) {
        // Try multiple selectors for variant ID
        const variantInput = form.querySelector('input[name="id"]') || 
                            form.querySelector('input[name="variant_id"]') ||
                            form.querySelector('[name="id"]') ||
                            form.querySelector('input[type="hidden"][name*="variant"]');
        if (variantInput && variantInput.value) {
          variantId = variantInput.value;
        }
      }

      // Method 3: Try to get from data attributes or Shopify theme variables
      if (!variantId && typeof window.Shopify !== 'undefined') {
        // Some themes store variant ID in window.Shopify
        if (window.Shopify.selectedVariant) {
          variantId = window.Shopify.selectedVariant;
        }
      }

      // Method 4: Try to get from form data attribute
      if (!variantId && form.dataset && form.dataset.variantId) {
        variantId = form.dataset.variantId;
      }

      // Get quantity from form
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10) || 1;
      }

      // Validate we have required data
      if (!productId || !variantId) {
        console.error('Missing product or variant information', {
          productId,
          variantId,
          hasShopifyAnalytics: typeof ShopifyAnalytics !== 'undefined',
          formHTML: form.innerHTML.substring(0, 200)
        });
        alert('Unable to open builder. Please refresh the page and try again.');
        return;
      }

      // Build builder URL without adding to cart
      const builderUrl = `https://gangsheetbuilder.pixelflowdtf.com/?productId=${productId}&variantId=${variantId}&shopId=${shopID}&url=${window.location.origin}&quantity=${quantity}`;

      // Create iframe container
      const iframeContainer = document.createElement('div');
      iframeContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: white;
      `;

      const iframe = document.createElement('iframe');
      iframe.src = builderUrl;
      iframe.style.cssText = `
        width: 100%;
        height: 100%;
        border: none;
      `;

      iframeContainer.appendChild(iframe);
      document.body.appendChild(iframeContainer);
    } catch (err) {
      console.error('Error opening builder:', err);
      alert('Unable to open builder. Please refresh the page and try again.');
    }
  })();
}

document.addEventListener('click', handleCustomAddToCartClick);
